module.exports = __webpack_public_path__ + "media/images/story/icon/dots-vertical-5ad10f651790ccc9ccc644f727514f98.svg";